import React from 'react';
import './NotchSpacing.css';

const NotchSpacing = () => <div className="NotchSpacing" />;

export default NotchSpacing;
